import {TipoDocumentoDTO} from './TipoDocumentoDTO';
import {PaisDTO} from './PaisDTO';

export class ReceptorCFEDTO
{
  codigo: number;
  tipoDocumento: TipoDocumentoDTO;
  pais: PaisDTO;
  documento: string;
  razonSocial: string;
  direccion: string;
  ciudad: string;
  departamento: string;
  estaUsadoEnCFE: boolean;
  tienePadre: boolean;
  identificadorCompra?: string;
  isChecked?: boolean;

  constructor()
  {
    this.limpiar();
  }

  public limpiar(): void
  {
    this.codigo = null;
    this.tipoDocumento = null;
    this.pais = null;
    this.documento = null;
    this.razonSocial = null;
    this.direccion = null;
    this.ciudad = null;
    this.departamento = null;
    this.estaUsadoEnCFE = false;
    this.tienePadre = false;
    this.identificadorCompra = null;
    this.isChecked = false;
  }

  public toString(): string
  {
    const receptorCFEDTOStr: string = '(Tipo documento: ' + this.tipoDocumento.descripcion + ', ' +
                                       'Código país: ' + this.pais.descripcion + ', Documento: ' + this.documento + ', ' +
                                       'Razón social: ' + this.razonSocial + ', Dirección: ' + this.direccion + ', ' +
                                       'Ciudad: ' + this.ciudad + ', Departamento: ' + this.departamento + ', Identificador de compra: ' + this.identificadorCompra + ')';

    return receptorCFEDTOStr;
  }
}
